module.exports = __webpack_public_path__ + "static/media/Logo.b31777f0.svg";